import { Record } from '../transit'

const Test = Record({
  id: '',
  name: '',
  words: '',
  testId: '',
  isPublic: false,
  wordboxes: null,
  lessons: null,
  createdBy: null,
  newResults: false,
}, 'test')

export default Test



// WEBPACK FOOTER //
// ./src/common/tests/Test.js